export default __webpack_public_path__ + "static/media/icon-figma-library.b46dcdc6.png";